import { LanguageCodeEnum as n, LocaleEnum as t } from "@systemeio/types";
import { localeLanguages as c } from "./locale-labels.mjs";
function r(o) {
  const e = Object.keys(t).find(
    (a) => t[a] === o
  );
  return e ? n[e] : n.ENGLISH;
}
function L(o) {
  const e = Object.keys(n).find(
    (a) => n[a] === o
  );
  return e ? t[e] : t.ENGLISH;
}
function l(o, e) {
  return e(c[o]);
}
export {
  r as getLanguageCodeByLocale,
  L as getLocaleByLanguageCode,
  l as getLocaleLanguage
};
